import Cookies from 'js-cookie'
const TokenKey = 'pingxuan_h5_token'
const TidKey = 'pingxuan_h5_tid'
const SidKey = 'pingxuan_h5_sid'
const IsAgreeKey = 'pingxuan_h5_isAgree'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getTid() {
  return Cookies.get(TidKey)
}

export function setTid(tid) {
  return Cookies.set(TidKey, tid)
}

export function removeTid() {
  return Cookies.remove(TidKey)
}

export function getSid() {
  return Cookies.get(SidKey)
}

export function setSid(sid) {
  return Cookies.set(SidKey, sid)
}

export function removeSid() {
  return Cookies.remove(SidKey)
}

export function getAgreement() {
  return Cookies.get(IsAgreeKey)
}

export function setAgreement(isAgree) {
  return Cookies.set(IsAgreeKey, isAgree)
}
